/**
 * De statussen van een held en de toegestane overgangen (SPEC §6.4).
 *
 * Gedeeld met de Worker, die ze afdwingt. Het scherm gebruikt dezelfde tabel
 * om knoppen te tonen of te verbergen.
 */

export type Heldstatus = 'aangemeld' | 'actief' | 'verlopen' | 'opgezegd';

export const STATUSNAMEN: Record<Heldstatus, string> = {
  aangemeld: 'Aangemeld',
  actief: 'Actief',
  verlopen: 'Verlopen',
  opgezegd: 'Opgezegd',
};

const OVERGANGEN: Record<Heldstatus, readonly Heldstatus[]> = {
  aangemeld: ['actief', 'opgezegd'],
  actief: ['verlopen', 'opgezegd'],
  verlopen: ['actief', 'opgezegd'],
  // Heractiveren door het beheer, of een nieuwe aanmelding op hetzelfde adres.
  opgezegd: ['actief', 'aangemeld'],
};

export function magNaar(van: Heldstatus, naar: Heldstatus): boolean {
  return OVERGANGEN[van].includes(naar);
}

/** Staat deze held op de muur en wordt hij geïncasseerd? */
export function isInGoedeStand(status: Heldstatus): boolean {
  return status === 'actief';
}

export function alsHeldstatus(waarde: unknown): Heldstatus | null {
  return waarde === 'aangemeld' || waarde === 'actief' || waarde === 'verlopen' || waarde === 'opgezegd'
    ? waarde
    : null;
}
